/*
 * @@Author: MuYang
 */
export const COMPONENTS_NAMES = {
  page: 'page-render',
  popup: 'popup-render',
  summary: 'summary-render',
  form: 'form-render',
  header: 'header-render',
  formItem: 'form-item-render',
  tabs: 'tabs-render',
  tabItem: 'tab-item-render',
  filter: 'filter-render',

  list: 'list-layout',
  table: 'table-render',
  buttons: 'buttons-render',

  staticArea: 'tip-render',

  field: 'field-render',
  viewField: 'field-render',
  group: 'group-render',
  // interLayer: 'inter-layer',

  'paas-percentage': 'percentage', // 百分数
  'paas-shortText': 'short-text',
  'paas-textArea': 'text-area',
  'paas-autoNumber': 'auto-number',
  'paas-singleChoice': 'single-choice',
  'paas-multipleChoices': 'multiple-choices',
  'paas-boole': 'boole',
  'paas-number': 'number',
  'paas-currency': 'currency',
  'paas-date': 'date',
  'paas-dateTime': 'date-time',
  'paas-period': 'period',
  businessAddress: 'business-address',
  'paas-address': 'sy-address',
  'paas-department': 'department',
  'paas-personnel': 'personnel',
  masterDetailRelationship: 'master-detail-relationship',
  masterRelation: 'master-relation',
  polymericList: 'master-relation',
  'paas-lookupRelationship': 'lookup-relationship',
  'paas-masterDetailRelationship': 'master-relationship',
  lookup_relation: 'lookup_relation',
  'paas-quote': 'quote',
  'paas-region': 'sy-region',
  'paas-image': 'sy-image',
  'paas-file': 'sy-file',
  'paas-dropDown': 'drop-down',
  'paas-dropDownTree': 'drop-down-tree',
  'paas-special': 'special',
  'fieldGroup': 'field-group-render',
  'cards': 'card-render',
  'footer': 'footer-render'
}
